import { useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import { t } from "../../services";
import { FlexContainers, Paragraph2, WrapperContainer } from "../../components";
import { LinkStyled } from "./styled";

const NavLink = ({ to, title, icon, inactiveIcon, onClick = () => {}, disabled = false }) => {
  const [isHovered, setIsHovered] = useState(false);

  const location = useLocation();

  const isActive = useMemo(() => {
    return to && location.pathname.includes(to) ? 1 : 0;
  }, [location, to]);

  return (
    <LinkStyled
      as={to ? Link : "button"}
      to={to}
      onClick={onClick}
      active={isActive}
      disabled={disabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      <WrapperContainer
        Container={FlexContainers.FlexColumnBetween}
        width={"100%"}
        height={"56px"}
        pr={2}
        pv={10}>
        {!isActive && inactiveIcon && !isHovered ? inactiveIcon : icon}
        <Paragraph2>{t(title)}</Paragraph2>
      </WrapperContainer>
    </LinkStyled>
  );
};

NavLink.propTypes = {
  to: PropTypes.string,
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  inactiveIcon: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};

export default NavLink;
